import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { toDataUrl } from '@/utils/common';
export interface ReportHeaderLayoutProps {
    children: ReactNode;
}

const lightLogo = new URL('@/public/logo/rectangle/black.svg', import.meta.url).href;
const darkLogo = new URL('@/public/logo/rectangle/white.svg', import.meta.url).href;
const waveBg = new URL('@/public/images/dashboard-welcome-wave.png', import.meta.url).href;

const ReportHeaderLayout = ({ children }: ReportHeaderLayoutProps) => {
    const [lightLogoBase64, setLightLogoBase64] = useState<string | null>(null);
    const [darkLogoBase64, setDarkLogoBase64] = useState<string | null>(null);
    const [waveBase64, setWaveBase64] = useState<string | null>(null);

    useEffect(() => {
        toDataUrl(lightLogo)
            .then(setLightLogoBase64)
            .catch(err => {
                console.warn(`ReportHeaderLayout: failed to generate base64 for light logo`, err);
            });
        toDataUrl(darkLogo)
            .then(setDarkLogoBase64)
            .catch(err => {
                console.warn(`ReportHeaderLayout: failed to generate base64 for dark logo`, err);
            });
        toDataUrl(waveBg)
            .then(setWaveBase64)
            .catch(err => {
                console.warn(`ReportHeaderLayout: failed to generate base64 for wave background`, err);
            });
    }, []);

    return (
        <header className="bg-neutral-0 relative overflow-hidden rounded-md p-6 print:shadow-none">
            <div
                aria-hidden="true"
                className="pointer-events-none absolute right-0 bottom-0 h-25 w-140 bg-size-[450%_400%] bg-position-[-10px_-170px] bg-no-repeat"
                style={{ backgroundImage: `url(${waveBase64 || waveBg})` }}
            />
            <div className="relative flex items-start justify-between">
                {children}
                <img
                    src={lightLogoBase64 || lightLogo}
                    alt="NeuroVibes"
                    className="ml-4 h-7 w-auto drop-shadow-sm dark:hidden"
                    draggable={false}
                />
                <img
                    src={darkLogoBase64 || darkLogo}
                    alt="NeuroVibes"
                    className="ml-4 hidden h-7 w-auto drop-shadow-sm dark:block"
                    draggable={false}
                />
            </div>
        </header>
    );
};

export default ReportHeaderLayout;
